import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { initAnalytics } from '@/config/init-analytics'

import { App } from './app'

initAnalytics()

const rootElement = document.getElementById('root')
if (rootElement) {
  const root = createRoot(rootElement)

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
